import React, { useEffect, useRef, useState } from "react";
type Sale = {
  name: string;
  city: string;
  product: string;
  price: number;
  minutesAgo: number;
};
function pickOne<T>(arr: T[]) {
  return arr[Math.floor(Math.random() * arr.length)];
}
function isMobileNow() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(max-width: 768px)").matches;
}
function pickWeightedProduct() {
  // 70% Bundle, 20% Libro físico, 10% Audio
  const r = Math.random();
  if (r < 0.7) return {
    product: "Bundle Completo Premium (PDF + MP3 + Bonos)",
    price: 19
  };
  if (r < 0.9) return {
    product: "Libro Físico: 30 Días para una Fe que Transforma",
    price: 49
  };
  return {
    product: "Audio Devocional (MP3)",
    price: 12
  };
}
function generateSale(): Sale {
  const names = ["María", "José", "Ana", "Luis", "Carmen", "Juan", "Sofía", "Miguel", "Valeria", "Carlos", "Lucía", "Andrés", "Elena", "Daniel", "Paola", "Fernanda", "Ricardo", "Gabriela"];
  const cities = ["Houston, TX", "Miami, FL", "Phoenix, AZ", "New York, NY", "Los Ángeles, CA", "Chicago, IL", "Las Vegas, NV", "Orlando, FL", "Atlanta, GA", "Dallas, TX", "Tampa, FL", "Denver, CO"];
  const p = pickWeightedProduct();
  return {
    name: pickOne(names),
    city: pickOne(cities),
    product: p.product,
    price: p.price,
    minutesAgo: Math.floor(Math.random() * 12) + 1
  };
}
export default function SalesNotification() {
  const [isMobile, setIsMobile] = useState(isMobileNow());
  const [isVisible, setIsVisible] = useState(false);
  const [sale, setSale] = useState<Sale>(() => generateSale());
  const [animKey, setAnimKey] = useState(0);
  const intervalRef = useRef<number | null>(null);
  const hideRef = useRef<number | null>(null);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const handler = () => setIsMobile(mq.matches);
    handler();
    mq.addEventListener?.("change", handler);
    return () => mq.removeEventListener?.("change", handler);
  }, []);
  useEffect(() => {
    // Apaga timers si no es móvil
    if (!isMobile) {
      setIsVisible(false);
      if (intervalRef.current) window.clearInterval(intervalRef.current);
      if (hideRef.current) window.clearTimeout(hideRef.current);
      intervalRef.current = null;
      hideRef.current = null;
      return;
    }
    const showOnce = () => {
      setSale(generateSale());
      setAnimKey(k => k + 1);
      setIsVisible(true);
      if (hideRef.current) window.clearTimeout(hideRef.current);
      hideRef.current = window.setTimeout(() => setIsVisible(false), 3200);
    };

    // Primer popup
    const first = window.setTimeout(showOnce, 1200);

    // Loop
    intervalRef.current = window.setInterval(showOnce, 6500);
    return () => {
      window.clearTimeout(first);
      if (intervalRef.current) window.clearInterval(intervalRef.current);
      if (hideRef.current) window.clearTimeout(hideRef.current);
      intervalRef.current = null;
      hideRef.current = null;
    };
  }, [isMobile]);
  if (!isMobile) return null;
  return <div className={["sales-notification", isVisible ? "sales-notification--show" : "sales-notification--hide"].join(" ")} aria-live="polite" aria-atomic="true" data-id="element-168">
      <div key={animKey} className="sales-notification__card" data-id="element-169">
        <div className="sales-notification__top" data-id="element-170">
          <div className="sales-notification__dot" data-id="element-171" />
          <div className="sales-notification__title" data-id="element-172">Compra reciente</div>
          <div className="sales-notification__time" data-id="element-173">hace {sale.minutesAgo} min</div>
        </div>

        <div className="sales-notification__body" data-id="element-174">
          <div data-id="element-175">
            <strong data-id="element-176">{sale.name}</strong> de <strong data-id="element-177">{sale.city}</strong>
          </div>
          <div data-id="element-178">
            compró <span className="sales-notification__product" data-id="element-179">{sale.product}</span>
          </div>
          <div className="sales-notification__price" data-id="element-180">${sale.price}</div>
        </div>
      </div>
    </div>;
}